// import React, { useEffect, useState } from 'react';
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   Button,
// } from 'react-bootstrap';
// import { FaArrowLeft } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom';

// const ParentStudentProfile = () => {
//   const [marginLeft, setMarginLeft] = useState(
//     window.innerWidth > 768 ? '300px' : '0px',
//   )

//   useEffect(() => {
//     const handleResize = () => {
//       setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
//     }

//     window.addEventListener('resize', handleResize)
//     return () => window.removeEventListener('resize', handleResize)
//   }, [])
//   const navigate = useNavigate()

//   // ✅ Hardcoded Student Data
//   const data = {
//     id: 1,
//     name: 'Rahul Sharma',
//     admission_number: 'A12345',
//     admission_date: '2023-06-15',
//     email: 'rahul.sharma@example.com',
//     gender: 'Male',
//     dob: '2005-09-10',
//     address: '123, MG Road, Delhi',
//     id_proof_number: 'AADHAR123456',
//     father_name: 'Ramesh Sharma',
//     mother_name: 'Sunita Sharma',
//     phone: '9876543210',
//     parents_number: '9876501234',
//     whatsapp_number: '9876543210',
//     status: 'active',
//     institute_id: 1,
//     course_id: 101,
//     class_id: 5,
//   };

//   const img = {
//     student_image:
//       'https://via.placeholder.com/120x120.png?text=Student+Photo',
//   };

//   const institutes = [{ institute_id: 1, name: 'ABC Public School' }];

//   const handleViewFees = () => alert('View Fees');
//   const handleViewAttendance = () => alert('View Attendance');

//   const calculateAge = (dob) => {
//     if (!dob) return null;
//     const birthDate = new Date(dob);
//     const diff = Date.now() - birthDate.getTime();
//     const age = new Date(diff).getUTCFullYear() - 1970;
//     return age;
//   };

//   return (
//     <div style={{ marginLeft }}>
//       {data ? (
//         <>
//           <div
//             className="container-fluid p-0"
//             style={{
//               marginTop: window.innerWidth < 768 ? '55px' : '-12px',
//             }}
//           >
//             <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
//               <div className="m-0">
//                 <h2 className="mb-0">
//                   <span className="text-warning">
//                     {data.name
//                       ? data.name.charAt(0).toUpperCase() +
//                         data.name.slice(1).toLowerCase()
//                       : ''}
//                   </span>
//                   's Profile
//                 </h2>
//               </div>
//               <div className="d-flex gap-2 ms-auto">
//                 <Button
//                   variant="outline-light"
//                   className="border-white responsive-btn"
//                   onClick={()=> navigate("/Student/List")}
//                 >
//                   <FaArrowLeft /> Go to Student List
//                 </Button>
//               </div>
//             </div>
//           </div>

//           <Container className="mt-4">
//             <Card className="border-0 shadow-sm">
//               <Card.Body>
//                 <Row className="align-items-center text-center text-md-start">
//                   <Col
//                     md={2}
//                     className="text-center justify-content-center d-flex align-items-center mt-4 mb-2"
//                   >
//                     {img?.student_image ? (
//                       <img
//                         src={img.student_image}
//                         className="rounded-circle border border-3 shadow-sm"
//                         alt="Profile"
//                         style={{
//                           width: '120px',
//                           height: '120px',
//                           border: '3px solid #007bff',
//                           background: 'white',
//                         }}
//                       />
//                     ) : (
//                       <div
//                         className="d-flex align-items-center justify-content-center rounded-circle border border-3 shadow-sm"
//                         style={{
//                           width: '120px',
//                           height: '120px',
//                           border: '3px solid #007bff',
//                           background: 'white',
//                           textAlign: 'center',
//                           fontSize: '14px',
//                           color: '#6c757d',
//                         }}
//                       >
//                         Photo not available
//                       </div>
//                     )}
//                   </Col>
//                   <Col md={8}>
//                     <h4 className="mb-0">{data?.name.toUpperCase()}</h4>
//                   </Col>
//                 </Row>

//                 {/* General Information */}
//                 <Row className="d-flex align-items-center justify-content-between">
//                   <Col xs={8} sm={9} className="text-start">
//                     <h4
//                       className="text-primary mt-3 mb-3 mb-sm-4 h-100"
//                       style={{ fontSize: 'clamp(1rem, 4vw, 1.5rem)' }}
//                     >
//                       General Information
//                     </h4>
//                   </Col>
//                 </Row>

//                 <Row className="g-3">
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Institute Name</small>
//                       <p>
//                         {institutes.find(
//                           (insti) => insti.institute_id === data.institute_id
//                         )?.name || 'N/A'}
//                       </p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Admission Number</small>
//                       <p className="mb-0">{data.admission_number}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Admission Date</small>
//                       <p className="mb-0">{data.admission_date}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Email Address</small>
//                       <p className="mb-0">{data.email}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Gender</small>
//                       <p className="mb-0">{data.gender}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Birth Date</small>
//                       <p className="mb-0">{data.dob}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Age</small>
//                       <p className="mb-0">{calculateAge(data.dob)}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Address</small>
//                       <p className="mb-0">{data.address}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">ID Proof Number</small>
//                       <p className="mb-0">{data.id_proof_number}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Father's Name</small>
//                       <p className="mb-0">{data.father_name}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Mother's Name</small>
//                       <p className="mb-0">{data.mother_name}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Phone Number</small>
//                       <p className="mb-0">{data.phone}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Parent's Number</small>
//                       <p className="mb-0">{data.parents_number}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">WhatsApp Number</small>
//                       <p className="mb-0">{data.whatsapp_number}</p>
//                     </div>
//                   </Col>
//                   <Col md={3} xs={6}>
//                     <div className="p-2 border rounded bg-white text-start h-100">
//                       <small className="text-muted">Status</small>
//                       <p className="mb-0 text-success">{data.status}</p>
//                     </div>
//                   </Col>
//                 </Row>

//                 <h4 className="text-primary mt-4 mb-4 text-start h-100">
//                   View More Details
//                 </h4>
//                 <Row className="mt-4 text-center">
//                   <Col xs={12} md={3} className="mb-2">
//                     <Button
//                       variant="primary"
//                       className="w-100"
//                       onClick={()=>navigate("/Student/Fees")}
//                     >
//                       Fees
//                     </Button>
//                   </Col>
//                   <Col xs={12} md={3} className="mb-2">
//                     <Button
//                       variant="warning"
//                       className="w-100 text-white"
//                       onClick={()=>navigate("/Student/Attendance")}
//                     >
//                       Attendance
//                     </Button>
//                   </Col>
//                 </Row>
//               </Card.Body>
//             </Card>
//           </Container>
//         </>
//       ) : (
//         <p>Loading student data...</p>
//       )}
//     </div>
//   );
// };

// export default ParentStudentProfile;


import { useEffect, useState } from 'react'
import React from 'react'
import { Container, Card, Row, Col, Button, Modal, Form } from 'react-bootstrap'
import { FaUserCircle, FaArrowLeft } from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import axios from 'axios'

const ViewStudent = ({ student }) => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const { id } = useParams()
  console.log('id:', id)
  const [data, setData] = useState('')
  console.log('data is define here', data)
  const navigate = useNavigate()

  const [studentData, setStudentData] = useState(null)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [institutes, setInstitutes] = useState([])
  const [opentDateModal, setOpenDateModal] = useState(false)
  const [highlightUpdate, setHighlightUpdate] = useState(false)
  const [leavingDate, setLeavingDate] = useState('')

  useEffect(() => {
    const storedInstitute = Cookies.get('institute_name')

    if (storedInstitute) {
      setInstitutes([{ name: storedInstitute }]) // ✅ Wrap in an array
    }
  }, [])
  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  useEffect(() => {
   
    const fetchAllClasses = async()=>{
      try {
       const institute_id = Cookies.get('institute_id')

        const headers = {
          institute_id : institute_id
        }
        const res = await axios.get(BASE_URL + "/class/all", {headers})
        setClasses(res.data.data)
      } catch (error) {
        console.error(error.response.data)
      }
    }
    fetchAllClasses()
  }, [])

  useEffect(() => {
    ApiEndpoints.getAllInstitutes().then((res) => {
      if (Array.isArray(res.data.data)) {
        setInstitutes(res.data.data)
      } else {
        setInstitutes([]) // Fallback to empty array
      }
    })
  }, [])

  const [img, setImg] = useState(null)
  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const response = await ApiEndpoints.viewProfile(id)
        console.log('Response of viewProfile: ', response.data.data)
        setData(response.data.data)
        setStudentData(response.data.data)
        setImg(response.data.data)
      } catch (error) {
        error(error.response?.data?.message || 'Something wents worng.')
      }
    }
    if (id) fetchStudentData()
  }, [id])
  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }

  const handleBack = () => {
    navigate('/Student/List')
  }

  const handleIdCard = () => {
    navigate(`/IDcard/${id}`)
  }
  const handleUpdateStudentProfile = () => {
    // setHighlightUpdate(true)

    // setTimeout(() => setHighlightUpdate(false), 3000)
    navigate(`/UpdateStudentProfile/${id}`)
  }
  const handleViewFees = (id, course_id, class_id) => {
    // navigate(`/StudentFees/${id}/${course_id}/${class_id}`)
    navigate(`/Student/Fees/${id}`)
    console.log('Student ID:', id)
    console.log('Course ID:', course_id)
    console.log('Class ID:', class_id)
  }

  const handleViewCourse = () => {
    const studentName = studentData?.name
    const admissionNumber = studentData?.admission_number

    navigate(`/EnrolledCourses/${id}`, {
      state: {
        student_id: id,
        student_name: studentName,
        admission_number: admissionNumber,
      },
    })
    console.log('EnrolledCourses', id)
    console.log('studentName', studentName)
  }
  const handleViewAttendance = (id, course_id, class_id) => {
    if (!course_id || !class_id) {
      toast.error('Please add course and class first.')
      setHighlightUpdate(true)
      setTimeout(() => setHighlightUpdate(false), 5000)
    } else {
      navigate(`/Student/Attendance/${id}/${course_id}/${class_id}`)
      console.log('Student ID:', id)
      console.log('Course ID:', course_id)
      console.log('Class ID:', class_id)
    }
  }
  const handleDischarge = () => {
    setOpenDateModal(true)
    // navigate('/DischargedStudent')
  }
  // const handleViewResult = () => {
  // navigate(`/IDcard/${id}`)
  // }

  const handleDischargeNow = async (e) => {
    e.preventDefault()
    if (!leavingDate) {
      toast.error('Please select a leaving date.')
      return
    }
    const userCookie = Cookies.get('user')
    if (!userCookie) {
      toast.error('User not authenticated. Please log in.')
      return
    }

    try {
      const status = 'inactive'

      const user = JSON.parse(userCookie)
      let token = user.token

      const response = await axios.post(
        BASE_URL+`/students/${id}/status?status=${status}&leaving_date=${leavingDate}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      toast.success(response.data.message)
      navigate('/DischargedStudent')
    } catch (error) {
      console.error(error.response?.data?.message)
    }
  }

  const handleViewMarksheet = (id, course_id, class_id)=>{
    if (!course_id || !class_id) {
      toast.error('Please add course and class first.')
      setHighlightUpdate(true)
      setTimeout(() => setHighlightUpdate(false), 5000)
    } else {
      navigate(`/ExamMarksheet/${id}/${course_id}/${class_id}`)
      console.log('Student ID:', id)
      console.log('Course ID:', course_id)
      console.log('Class ID:', class_id)
    }
  }

  return (
    <>
      <style>
        {`
          .hover-button:hover {
            box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15);
            transform: scale(1.02);
            transition: all 0.2s ease-in-out;
          }
       .blink-updateButton {
          animation: blink 0.5s linear infinite;
          border: 2px solid #ff9900 !important;
        }

        @keyframes blink {
          50% {
            opacity: 0.5;
          }
        }
          @media (max-width: 768px) {
          .responsive-btn {
            margin-top:5px !important;
            padding: 0.25rem 0.5rem !important;
            font-size: 12px !important;
          }
         }
        `}
      </style>

      <div style={{ marginLeft }}>
        {data ? (
          <>
            <div
              className="container-fluid p-0"
              style={{
                marginTop: window.innerWidth < 768 ? '55px' : '-12px',
              }}
            >
              <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
                <div className="m-0">
                  <h2 className="mb-0">
                    <span className="text-warning">
                      {data.name
                        ? data.name.charAt(0).toUpperCase() +
                          data.name.slice(1).toLowerCase()
                        : ''}
                    </span>
                    's Profile
                  </h2>
                </div>
                <div className="d-flex gap-2 ms-auto">
                  {/* <Button
                    variant="outline-light"
                    // className="border-white"
                    className={` border-white hover-button responsive-btn ${
                      highlightUpdate ? 'blink-updateButton' : ''
                    }`}
                    // onClick={handleUpdateStudentProfile}
                    onClick={() => {
                      handleUpdateStudentProfile(
                        data.id,
                        // data.course_id,
                        // data.class_id,
                      )
                    }}
                  >
                    Update {data.name} Profile
                  </Button> */}
                  <Button
                    variant="outline-light"
                    className="border-white responsive-btn"
                    onClick={handleBack}
                  >
                    <FaArrowLeft /> Go to Student List
                  </Button>
                </div>
              </div>
            </div>
            <Container className="mt-4">
              {/* Back Button */}

              {/* Student Profile Card */}
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <Row className="align-items-center text-center text-md-start">
                    <Col
                      md={2}
                      className="text-center justify-content-center d-flex align-items-center mt-4 mb-2"
                    >
                      {img?.student_image ? (
                        <img
                          src={img.student_image}
                          className="rounded-circle border border-3 shadow-sm"
                          alt="Profile"
                          style={{
                            width: '120px',
                            height: '120px',
                            border: '3px solid #007bff',
                            background: 'white',
                          }}
                        />
                      ) : (
                        <div
                          className="d-flex align-items-center justify-content-center rounded-circle border border-3 shadow-sm"
                          style={{
                            width: '120px',
                            height: '120px',
                            border: '3px solid #007bff',
                            background: 'white',
                            textAlign: 'center',
                            fontSize: '14px',
                            color: '#6c757d',
                          }}
                        >
                          Photo not available
                        </div>
                      )}
                    </Col>
                    <Col md={8}>
                      <h4 className="mb-0">
                        {data?.name.toUpperCase() || 'N/A'}
                      </h4>
                    </Col>
                  </Row>

                  {/* General Information */}
                  <Row className="d-flex align-items-center justify-content-between">
                    <Col xs={8} sm={9} className="text-start">
                      <h4
                        className="text-primary mt-3 mb-3 mb-sm-4 h-100"
                        style={{ fontSize: 'clamp(1rem, 4vw, 1.5rem)' }}
                      >
                        {' '}
                        General Information
                      </h4>
                    </Col>
                    {/* <Col xs={4} sm={3} className="text-end">
                      <Button size="sm" className="py-" onClick={handleIdCard}>
                        Print ID Card
                      </Button>
                    </Col> */}
                  </Row>
                  <Row className="g-3">
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Institute Name</small>
                        <p>
                          {data?.institute_id
                            ? institutes?.find(
                                (insti) =>
                                  insti.institute_id === data.institute_id,
                              )?.name || 'N/A'
                            : null}{' '}
                        </p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Admission Number</small>
                        <p className="mb-0">
                          {data?.admission_number || 'N/A'}
                        </p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Admission Date</small>
                        <p className="mb-0">{data?.admission_date || 'N/A'}</p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Email Address</small>
                        <p className="mb-0">{data?.email || 'N/A'}</p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Gender</small>
                        <p className="mb-0">{data?.gender || 'N/A'}</p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Birth Date</small>
                        <p className="mb-0">{data?.dob || 'N/A'}</p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Age</small>
                        <p className="mb-0">
                          {calculateAge(data?.dob) || 'N/A'}
                        </p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Address</small>
                        <p className="mb-0">{data?.address || 'N/A'}</p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">ID Poof Number</small>
                        <p className="mb-0">{data?.id_proof_number || 'N/A'}</p>
                      </div>
                    </Col>

                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Father's Name</small>
                        <p className="mb-0">{data?.father_name || 'N/A'}</p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Mother's Name</small>
                        <p className="mb-0">{data?.mother_name || 'N/A'}</p>
                      </div>
                    </Col>

                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Phone Number</small>
                        <p className="mb-0">{data?.phone || 'N/A'}</p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Parent's Number</small>
                        <p className="mb-0">{data?.parents_number || 'N/A'}</p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">WhatsApp Number</small>
                        <p className="mb-0">{data?.whatsapp_number || 'N/A'}</p>
                      </div>
                    </Col>
                    {/* <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Course</small>
                        <p className="mb-0">
                          {data?.course_id
                            ? courses.find(
                                (course) => course.id === data.course_id,
                              )?.name || 'N/A'
                            : 'N/A'}
                        </p>
                      </div>
                    </Col> */}
                    {/* <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Classes</small>
                        <p className="mb-0">
                          {data?.course_id
                            ? classes.find((cls) => cls.id === data.class_id)
                                ?.class_name || 'N/A'
                            : 'N/A'}
                        </p>
                      </div>
                    </Col> */}

                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Status</small>
                        <p className="mb-0 text-success">
                          {data?.status
                            ? data.status.charAt(0).toUpperCase() +
                              data.status.slice(1)
                            : 'N/A'}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <h4 className="text-primary mt-4 mb-4 text-start h-100">
                    View More Details
                  </h4>
                  <Row className="mt-4 text-center">
                    <Col xs={12} md={3} className="mb-2">
                      <Button
                        variant="primary"
                        className="w-100 hover-button"
                        onClick={() =>
                          handleViewFees(data.id, data.course_id, data.class_id)
                        }
                      >
                        Fees
                      </Button>
                    </Col>
                    {/* <Col xs={12} md={3} className="mb-2">
                      <Button
                        variant="success"
                        className="w-100 hover-button"
                        onClick={handleViewCourse}
                      >
                        Enrolled Courses
                      </Button>
                    </Col> */}
                    <Col xs={12} md={3} className="mb-2">
                      <Button
                        variant="warning"
                        className="w-100 text-white hover-button"
                        onClick={() =>
                          handleViewAttendance(
                            data.id,
                            data.course_id,
                            data.class_id,
                          )
                        }
                      >
                        Attendance
                      </Button>
                    </Col>
                    
                     {/* <Col xs={12} md={3} className="mb-5">
                          <Button
                        variant="info"
                        className="w-100 text-white hover-button"
                        onClick={() =>
                          handleViewMarksheet(
                            data.id,
                            data.course_id,
                            data.class_id,
                          )
                        }
                      >
                        View Marksheet
                      </Button>
                    </Col> */}
                    {/* <Col xs={12} md={3} className="mb-2">
                      <Button
                        variant="danger"
                        className="w-100 hover-button"
                        onClick={handleViewResult}
                      >
                        Result
                      </Button>
                    </Col> */}
                  </Row>
                </Card.Body>
              </Card>
            </Container>
          </>
        ) : (
          <p>Loading student data...</p>
        )}
      </div>
      <Modal
        centered
        show={opentDateModal}
        onHide={() => setOpenDateModal(false)}
      >
        <Modal.Header closeButton className="bg-danger text-white">
          <Modal.Title>Select Leaving Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Select Date</Form.Label>
              <Form.Control
                type="date"
                name="leaving_date"
                value={leavingDate}
                onChange={(e) => setLeavingDate(e.target.value)}
              />
            </Form.Group>
          </Form>
          <Modal.Footer>
            <Button
              variant="outline-secondary"
              onClick={() => setOpenDateModal(false)}
            >
              Close
            </Button>
            <Button variant="outline-danger" onClick={handleDischargeNow}>
              Leave Now
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ViewStudent
